import { useQuery } from "@apollo/client";
import { BUYING_LIMITATIONS } from "../pharmacyTypeDefs";

export const useQueryBuyingLimitations = (options?: any): any => (
  useQuery(BUYING_LIMITATIONS, options)
);
